module.exports = __webpack_public_path__ + "img/dining-lounge.5af91fbf.webp";